/* eslint-disable import/prefer-default-export */
export const companyCol = [
  'About Netmeds',
  'Customers Speak',
  'In the News',
  'Career',
  'Terms & Conditions',
  'Privacy Policy',
  'Contact',
];

export const shoppingCol = [
  'Browse by A-Z',
  'Browse by Manufacturers',
  'Health Articles',
  'Offers/Coupons',
  'FAQs',
];

export const categoriesCol = [
  'Ayush',
  'Devices',
  'Family Care',
  'Fitness',
  'Lifestyle',
  'Personal Care',
  'Treatments',
];

export const social = [
  'Patients Alike',
  'Facebook',
  'Twitter',
  'LinkedIn',
  'Youtube',
  'Refer & Earn',
];

export const newsletterText =
  'Get a free subscription to our health and fitness tip and stay tuned to our latest offers';
